import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon, object = logged
  const [adminExists, setAdminExists] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/setup-status");
      setAdminExists(data.admin_exists);
    } catch {
      setAdminExists(true);
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) { console.debug("logout request failed (ignoring)", e?.message); }
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, adminExists, setAdminExists, refresh, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
